export default {
  en: {
    incentive: 'Incentive',
    metric: 'Metric',
    scoring: 'Scoring',
    commsHub: 'CommsHub',

    // CustomIncentive.vue
    addCustomIncentive: 'ADD CUSTOM INCENTIVE',
    addGlobalIncentive: 'Add Global Incentive (QSRsoft Admin)',
    globalIncentives: 'Global Incentives',
    globalIncentivesDescription: 'Create incentives that apply across all business units. Only QSRsoft system admins can manage these.',
    maxIncentivesPerBU: 'Maximum of 5 incentives per business unit',
    incentiveSavedSuccess: 'Incentive saved successfully!',
    incentiveDeletedSuccess: 'Incentive deleted successfully!',
    incentiveSaveFailed: 'Failed to save incentive. Please try again.',
    incentiveDeleteFailed: 'Failed to delete incentive. Please try again.',
    incentiveApprovedSuccess: 'Incentive approved successfully!',
    incentiveApproveFailed: 'Failed to approve incentive. Please try again.',

    // wizard.vue
    editCustomIncentive: 'Edit Custom Incentive',
    addCustomIncentiveTitle: 'Add Custom Incentive',
    basicInfo: 'Basic Info',
    metrics: 'Metrics',
    weighting: 'Weighting',
    additionalInfo: 'Additional Info',
    previewAndSubmit: 'Preview & Submit',
    cancel: 'Cancel',
    saveAndClose: 'Save & Close',
    configureStep: 'Configure {step}',

    // BasicInfo.vue
    businessUnit: 'Business Unit',
    incentiveName: 'Incentive Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    addPracticeStartDate: 'Add Practice Start Date',
    practiceStartDate: 'Practice Start Date',
    displayEndDate: 'Display End Date',
    practiceTooltip:
      'BU can show an incentive early for "practice weeks,"\nwhen incentive is visible to restaurants but do not\ncount toward final results until the official start date',
    displayEndTooltip:
      "The last day this incentive will be shown on TV slide\n(to keep Crew Members up-to-date). Scoring stops\non the incentive's actual end date, not the display end date.",
    incentiveNameRequired: 'Incentive name is required',
    incentiveNameInvalid:
      "Only letters, numbers, $, %, and ' symbols are allowed",
    acceptCurrentConfiguration: 'Accept current configuration',

    // Metrics.vue
    selectMetricsDescription:
      'Select the metrics and timeslices for your new incentive',
    addMetric: 'Add Metric',
    maxMetricsReached: 'Maximum of 5 metrics reached',

    // MetricRow.vue
    selectMetric: 'Select Metric',
    selectTimeslice: 'Select Timeslice',

    // ScoringRules.vue
    configureMetricsFirst:
      'Configure Metrics in the previous step to enable Scoring Rules.',
    decideWeighing: 'Decide the weighing of each metric',
    mustTotal100: '(must total 100%)',
    weightValidationError:
      'Total desired weights must add up to 100%. Current total: {total}%',
    weightMustBeGreaterThanZero: 'Weight must be higher than 0%',

    // Notes.vue
    notesPlaceholder:
      'List any relevant information. Please be aware that anything you enter here will be displayed to anyone with access to the MYQ Homepage for operators.',
    acceptCurrentNotes: 'Accept current notes',

    // PointCalcs.vue
    desiredWeight: 'Desired Weight (%)',

    // IncentivePreview.vue
    incentiveNameLabel: 'Incentive Name',
    unnamedIncentive: 'Unnamed Incentive',
    dates: 'Dates',
    metricsSection: 'Metrics',
    name: 'Name',
    timeslice: 'Timeslice',
    weight: 'Weight',
    createdBy: 'Created By',
    author: 'Author',
    createdDate: 'Created Date',
    notes: 'Notes',
    na: 'N/A',

    // IncentiveTable.vue
    customIncentives: 'Custom Incentives',
    kpis: 'KPIs',
    status: 'Status',
    approvedBy: 'Approved By',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete',
    statusLive: 'Live',
    statusPracticeMode: 'Practice Mode',
    statusAwaitingApproval: 'Awaiting Approval',
    statusScheduled: 'Scheduled',
    statusCompleted: 'Completed',
    statusArchived: 'Archived',
    statusScheduledTooltip:
      'Approved and waiting for practice period to begin',
    statusCompletedTooltip: 'Results still visible to crew',
    statusArchivedTooltip: 'Fully finished, results no longer visible',

    // ApprovalDialog.vue
    approved: 'Approved',
    needsApproval: 'Needs Approval',
    approve: 'Approve',
    view: 'View',
    customIncentiveDetails: 'Custom Incentive Details',
    close: 'Close',

    // ExampleWidget.vue
    timeframe: 'Timeframe',
    week: 'Week {n}',
    customIncentive: 'Custom Incentive',
    nsn: 'NSN',
    overallRank: 'Overall Rank',
    points: '(points)',
    totalPoints: 'Total Points',
    incentivePreview: 'Incentive Preview',
  },
  es: {
    incentive: 'Incentivo',
    metric: 'Métrica',
    scoring: 'Puntuación',
    commsHub: 'CommsHub',

    // CustomIncentive.vue
    addCustomIncentive: 'AGREGAR INCENTIVO PERSONALIZADO',
    addGlobalIncentive: 'Agregar Incentivo Global (Admin QSRsoft)',
    globalIncentives: 'Incentivos Globales',
    globalIncentivesDescription: 'Cree incentivos que se apliquen a todas las unidades de negocio. Solo los administradores de sistema de QSRsoft pueden gestionarlos.',
    maxIncentivesPerBU:
      'Máximo de 5 incentivos por unidad de negocio',
    incentiveSavedSuccess: '¡Incentivo guardado exitosamente!',
    incentiveDeletedSuccess: '¡Incentivo eliminado exitosamente!',
    incentiveSaveFailed:
      'Error al guardar el incentivo. Por favor, inténtelo de nuevo.',
    incentiveDeleteFailed:
      'Error al eliminar el incentivo. Por favor, inténtelo de nuevo.',
    incentiveApprovedSuccess: '¡Incentivo aprobado exitosamente!',
    incentiveApproveFailed:
      'Error al aprobar el incentivo. Por favor, inténtelo de nuevo.',

    // wizard.vue
    editCustomIncentive: 'Editar Incentivo Personalizado',
    addCustomIncentiveTitle: 'Agregar Incentivo Personalizado',
    basicInfo: 'Información Básica',
    metrics: 'Métricas',
    weighting: 'Ponderación',
    additionalInfo: 'Información Adicional',
    previewAndSubmit: 'Vista Previa y Enviar',
    cancel: 'Cancelar',
    saveAndClose: 'Guardar y Cerrar',
    configureStep: 'Configurar {step}',

    // BasicInfo.vue
    businessUnit: 'Unidad de Negocio',
    incentiveName: 'Nombre del Incentivo',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    addPracticeStartDate: 'Agregar Fecha de Inicio de Práctica',
    practiceStartDate: 'Fecha de Inicio de Práctica',
    displayEndDate: 'Fecha de Fin de Visualización',
    practiceTooltip:
      'La UN puede mostrar un incentivo anticipadamente para "semanas de práctica",\ncuando el incentivo es visible para los restaurantes pero no\ncuenta para los resultados finales hasta la fecha de inicio oficial',
    displayEndTooltip:
      'El último día que este incentivo se mostrará en la diapositiva de TV\n(para mantener a los miembros del equipo actualizados). La puntuación se detiene\nen la fecha de fin real del incentivo, no en la fecha de fin de visualización.',
    incentiveNameRequired: 'El nombre del incentivo es requerido',
    incentiveNameInvalid:
      'Solo se permiten letras, números y los símbolos $, % y \'',
    acceptCurrentConfiguration: 'Aceptar configuración actual',

    // Metrics.vue
    selectMetricsDescription:
      'Seleccione las métricas y franjas horarias para su nuevo incentivo',
    addMetric: 'Agregar Métrica',
    maxMetricsReached: 'Máximo de 5 métricas alcanzado',

    // MetricRow.vue
    selectMetric: 'Seleccionar Métrica',
    selectTimeslice: 'Seleccionar Franja Horaria',

    // ScoringRules.vue
    configureMetricsFirst:
      'Configure las Métricas en el paso anterior para habilitar las Reglas de Puntuación.',
    decideWeighing: 'Decida la ponderación de cada métrica',
    mustTotal100: '(debe sumar 100%)',
    weightValidationError:
      'Los pesos deseados deben sumar 100%. Total actual: {total}%',
    weightMustBeGreaterThanZero: 'El peso debe ser mayor que 0%',

    // Notes.vue
    notesPlaceholder:
      'Incluya cualquier información relevante. Tenga en cuenta que todo lo que ingrese aquí se mostrará a cualquier persona con acceso a la página de inicio de MYQ para operadores.',
    acceptCurrentNotes: 'Aceptar notas actuales',

    // PointCalcs.vue
    desiredWeight: 'Peso Deseado (%)',

    // IncentivePreview.vue
    incentiveNameLabel: 'Nombre del Incentivo',
    unnamedIncentive: 'Incentivo Sin Nombre',
    dates: 'Fechas',
    metricsSection: 'Métricas',
    name: 'Nombre',
    timeslice: 'Franja Horaria',
    weight: 'Peso',
    createdBy: 'Creado Por',
    author: 'Autor',
    createdDate: 'Fecha de Creación',
    notes: 'Notas',
    na: 'N/D',

    // IncentiveTable.vue
    customIncentives: 'Incentivos Personalizados',
    kpis: 'KPIs',
    status: 'Estado',
    approvedBy: 'Aprobado Por',
    actions: 'Acciones',
    edit: 'Editar',
    delete: 'Eliminar',
    confirmDelete: 'Confirmar Eliminación',
    confirmDeleteMessage: '¿Está seguro de que desea eliminar',
    statusLive: 'Activo',
    statusPracticeMode: 'Modo de Práctica',
    statusAwaitingApproval: 'Esperando Aprobación',
    statusScheduled: 'Programado',
    statusCompleted: 'Completado',
    statusArchived: 'Archivado',
    statusScheduledTooltip:
      'Aprobado y esperando que comience el período de práctica',
    statusCompletedTooltip: 'Resultados aún visibles para el equipo',
    statusArchivedTooltip:
      'Completamente finalizado, resultados ya no visibles',

    // ApprovalDialog.vue
    approved: 'Aprobado',
    needsApproval: 'Necesita Aprobación',
    approve: 'Aprobar',
    view: 'Ver',
    customIncentiveDetails: 'Detalles del Incentivo Personalizado',
    close: 'Cerrar',

    // ExampleWidget.vue
    timeframe: 'Período',
    week: 'Semana {n}',
    customIncentive: 'Incentivo Personalizado',
    nsn: 'NSN',
    overallRank: 'Rango General',
    points: '(puntos)',
    totalPoints: 'Puntos Totales',
    incentivePreview: 'Vista Previa del Incentivo',
  },
  fr: {
    incentive: 'Challenge',
    metric: 'Indicateur',
    scoring: 'Notation',
    commsHub: 'CommsHub',

    // CustomIncentive.vue
    addCustomIncentive: 'AJOUTER UN CHALLENGE PERSONNALISÉ',
    addGlobalIncentive: 'Ajouter un challenge global (admin QSRsoft)',
    globalIncentives: 'Challenges globaux',
    globalIncentivesDescription: 'Créez des challenges applicables à toutes les business units. Seuls les administrateurs système QSRsoft peuvent les gérer.',
    maxIncentivesPerBU: 'Maximum de 5 challenges par business unit',
    incentiveSavedSuccess: 'Challenge enregistré avec succès !',
    incentiveDeletedSuccess: 'Challenge supprimé avec succès !',
    incentiveSaveFailed: 'Échec de l’enregistrement du challenge. Veuillez réessayer.',
    incentiveDeleteFailed: 'Échec de la suppression du challenge. Veuillez réessayer.',
    incentiveApprovedSuccess: 'Challenge approuvé avec succès !',
    incentiveApproveFailed: 'Échec de l’approbation du challenge. Veuillez réessayer.',

    // wizard.vue
    editCustomIncentive: 'Modifier le challenge personnalisé',
    addCustomIncentiveTitle: 'Ajouter un challenge personnalisé',
    basicInfo: 'Informations de base',
    metrics: 'Indicateurs',
    weighting: 'Pondération',
    additionalInfo: 'Informations complémentaires',
    previewAndSubmit: 'Aperçu et envoi',
    cancel: 'Annuler',
    saveAndClose: 'Enregistrer et fermer',
    configureStep: 'Configurer {step}',

    // BasicInfo.vue
    businessUnit: 'Business unit',
    incentiveName: 'Nom du challenge',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    addPracticeStartDate: 'Ajouter une date de début d’entraînement',
    practiceStartDate: 'Date de début d’entraînement',
    displayEndDate: 'Date de fin d’affichage',
    practiceTooltip:
      'La BU peut afficher un challenge en avance pour des « semaines d’entraînement »,\npendant lesquelles le challenge est visible par les restaurants mais\nn’est pas comptabilisé dans les résultats finaux avant la date de début officielle',
    displayEndTooltip:
      'Dernier jour où ce challenge sera affiché sur l’écran TV\n(pour tenir les équipiers informés). La notation s’arrête\nà la date de fin réelle du challenge, pas à la date de fin d’affichage.',
    incentiveNameRequired: 'Le nom du challenge est obligatoire',
    incentiveNameInvalid:
      'Seuls les lettres, les chiffres et les symboles $, % et \' sont autorisés',
    acceptCurrentConfiguration: 'Accepter la configuration actuelle',

    // Metrics.vue
    selectMetricsDescription:
      'Sélectionnez les indicateurs et les plages horaires de votre nouveau challenge',
    addMetric: 'Ajouter un indicateur',
    maxMetricsReached: 'Maximum de 5 indicateurs atteint',

    // MetricRow.vue
    selectMetric: 'Sélectionner un indicateur',
    selectTimeslice: 'Sélectionner une plage horaire',

    // ScoringRules.vue
    configureMetricsFirst:
      'Configurez les indicateurs à l’étape précédente pour activer les règles de notation.',
    decideWeighing: 'Définissez la pondération de chaque indicateur',
    mustTotal100: '(le total doit faire 100 %)',
    weightValidationError:
      'Le total des pondérations souhaitées doit atteindre 100 %. Total actuel : {total} %',
    weightMustBeGreaterThanZero: 'La pondération doit être supérieure à 0 %',

    // Notes.vue
    notesPlaceholder:
      'Indiquez toute information utile. Attention : tout ce que vous saisissez ici sera visible par toute personne ayant accès à la page d’accueil MYQ des opérateurs.',
    acceptCurrentNotes: 'Accepter les notes actuelles',

    // PointCalcs.vue
    desiredWeight: 'Pondération souhaitée (%)',

    // IncentivePreview.vue
    incentiveNameLabel: 'Nom du challenge',
    unnamedIncentive: 'Challenge sans nom',
    dates: 'Dates',
    metricsSection: 'Indicateurs',
    name: 'Nom',
    timeslice: 'Plage horaire',
    weight: 'Pondération',
    createdBy: 'Créé par',
    author: 'Auteur',
    createdDate: 'Date de création',
    notes: 'Notes',
    na: 'S.O.',

    // IncentiveTable.vue
    customIncentives: 'Challenges personnalisés',
    kpis: 'KPI',
    status: 'Statut',
    approvedBy: 'Approuvé par',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMessage: 'Voulez-vous vraiment supprimer',
    statusLive: 'En cours',
    statusPracticeMode: 'Mode entraînement',
    statusAwaitingApproval: 'En attente d’approbation',
    statusScheduled: 'Planifié',
    statusCompleted: 'Terminé',
    statusArchived: 'Archivé',
    statusScheduledTooltip:
      'Approuvé et en attente du début de la période d’entraînement',
    statusCompletedTooltip: 'Résultats encore visibles par les équipiers',
    statusArchivedTooltip: 'Entièrement terminé, résultats plus visibles',

    // ApprovalDialog.vue
    approved: 'Approuvé',
    needsApproval: 'Approbation requise',
    approve: 'Approuver',
    view: 'Consulter',
    customIncentiveDetails: 'Détails du challenge personnalisé',
    close: 'Fermer',

    // ExampleWidget.vue
    timeframe: 'Période',
    week: 'Semaine {n}',
    customIncentive: 'Challenge personnalisé',
    nsn: 'NSN',
    overallRank: 'Classement général',
    points: '(points)',
    totalPoints: 'Total des points',
    incentivePreview: 'Aperçu du challenge',
  },
  'fr-ca': {
    incentive: 'Programme incitatif',
    metric: 'Indicateur',
    scoring: 'Pointage',
    commsHub: 'CommsHub',

    // CustomIncentive.vue
    addCustomIncentive: 'AJOUTER UN PROGRAMME INCITATIF PERSONNALISÉ',
    addGlobalIncentive: 'Ajouter un programme incitatif global (admin QSRsoft)',
    globalIncentives: 'Programmes incitatifs globaux',
    globalIncentivesDescription: 'Créez des programmes incitatifs applicables à toutes les unités d’affaires. Seuls les administrateurs système QSRsoft peuvent les gérer.',
    maxIncentivesPerBU: 'Maximum de 5 programmes incitatifs par unité d’affaires',
    incentiveSavedSuccess: 'Programme incitatif enregistré avec succès!',
    incentiveDeletedSuccess: 'Programme incitatif supprimé avec succès!',
    incentiveSaveFailed: 'Échec de l’enregistrement du programme incitatif. Veuillez réessayer.',
    incentiveDeleteFailed: 'Échec de la suppression du programme incitatif. Veuillez réessayer.',
    incentiveApprovedSuccess: 'Programme incitatif approuvé avec succès!',
    incentiveApproveFailed: 'Échec de l’approbation du programme incitatif. Veuillez réessayer.',

    // wizard.vue
    editCustomIncentive: 'Modifier le programme incitatif personnalisé',
    addCustomIncentiveTitle: 'Ajouter un programme incitatif personnalisé',
    basicInfo: 'Renseignements de base',
    metrics: 'Indicateurs',
    weighting: 'Pondération',
    additionalInfo: 'Renseignements supplémentaires',
    previewAndSubmit: 'Aperçu et soumission',
    cancel: 'Annuler',
    saveAndClose: 'Enregistrer et fermer',
    configureStep: 'Configurer {step}',

    // BasicInfo.vue
    businessUnit: 'Unité d’affaires',
    incentiveName: 'Nom du programme incitatif',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    addPracticeStartDate: 'Ajouter une date de début de la pratique',
    practiceStartDate: 'Date de début de la pratique',
    displayEndDate: 'Date de fin d’affichage',
    practiceTooltip:
      'L’unité d’affaires peut afficher un programme incitatif à l’avance pour des « semaines de pratique »,\npendant lesquelles il est visible par les restaurants mais\nn’est pas comptabilisé dans les résultats finaux avant la date de début officielle',
    displayEndTooltip:
      'Dernier jour où ce programme incitatif sera affiché à l’écran télé\n(pour tenir les équipiers au courant). Le pointage s’arrête\nà la date de fin réelle du programme, et non à la date de fin d’affichage.',
    incentiveNameRequired: 'Le nom du programme incitatif est obligatoire',
    incentiveNameInvalid:
      'Seuls les lettres, les chiffres et les symboles $, % et \' sont permis',
    acceptCurrentConfiguration: 'Accepter la configuration actuelle',

    // Metrics.vue
    selectMetricsDescription:
      'Sélectionnez les indicateurs et les plages horaires de votre nouveau programme incitatif',
    addMetric: 'Ajouter un indicateur',
    maxMetricsReached: 'Maximum de 5 indicateurs atteint',

    // MetricRow.vue
    selectMetric: 'Sélectionner un indicateur',
    selectTimeslice: 'Sélectionner une plage horaire',

    // ScoringRules.vue
    configureMetricsFirst:
      'Configurez les indicateurs à l’étape précédente pour activer les règles de pointage.',
    decideWeighing: 'Déterminez la pondération de chaque indicateur',
    mustTotal100: '(le total doit être de 100 %)',
    weightValidationError:
      'Le total des pondérations souhaitées doit être de 100 %. Total actuel : {total} %',
    weightMustBeGreaterThanZero: 'La pondération doit être supérieure à 0 %',

    // Notes.vue
    notesPlaceholder:
      'Indiquez tout renseignement pertinent. Veuillez noter que tout ce que vous saisissez ici sera visible par quiconque a accès à la page d’accueil MYQ des exploitants.',
    acceptCurrentNotes: 'Accepter les notes actuelles',

    // PointCalcs.vue
    desiredWeight: 'Pondération souhaitée (%)',

    // IncentivePreview.vue
    incentiveNameLabel: 'Nom du programme incitatif',
    unnamedIncentive: 'Programme incitatif sans nom',
    dates: 'Dates',
    metricsSection: 'Indicateurs',
    name: 'Nom',
    timeslice: 'Plage horaire',
    weight: 'Pondération',
    createdBy: 'Créé par',
    author: 'Auteur',
    createdDate: 'Date de création',
    notes: 'Notes',
    na: 'S.O.',

    // IncentiveTable.vue
    customIncentives: 'Programmes incitatifs personnalisés',
    kpis: 'IRC',
    status: 'Statut',
    approvedBy: 'Approuvé par',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMessage: 'Voulez-vous vraiment supprimer',
    statusLive: 'En cours',
    statusPracticeMode: 'Mode pratique',
    statusAwaitingApproval: 'En attente d’approbation',
    statusScheduled: 'Planifié',
    statusCompleted: 'Terminé',
    statusArchived: 'Archivé',
    statusScheduledTooltip:
      'Approuvé et en attente du début de la période de pratique',
    statusCompletedTooltip: 'Résultats encore visibles par les équipiers',
    statusArchivedTooltip: 'Entièrement terminé, résultats non visibles',

    // ApprovalDialog.vue
    approved: 'Approuvé',
    needsApproval: 'Approbation requise',
    approve: 'Approuver',
    view: 'Consulter',
    customIncentiveDetails: 'Détails du programme incitatif personnalisé',
    close: 'Fermer',

    // ExampleWidget.vue
    timeframe: 'Période',
    week: 'Semaine {n}',
    customIncentive: 'Programme incitatif personnalisé',
    nsn: 'NSN',
    overallRank: 'Classement général',
    points: '(points)',
    totalPoints: 'Total des points',
    incentivePreview: 'Aperçu du programme incitatif',
  },
};
